import { FunctionComponent } from 'react';

import { GestaoCondutorContainer } from '@components/GestaoCondutor/GestaoCondutor.container';

export const AppRoutes: Record<string, FunctionComponent<any>> = {
  '/': GestaoCondutorContainer,
};
